import { Injectable } from '@angular/core';

@Injectable()
export class UrlConfig {
  readonly accountManagementCenter!: string;
  readonly amaStoreAccount!: string;
  readonly amaStore!: string;
  readonly amaWire!: string;
  readonly createAccount!: string;
  readonly jama!: string;
  readonly joinRenew!: string;
  readonly journalOfEthics!: string;
  readonly login!: string;
  readonly logout!: string;
  readonly usan!: string;
}
